import NoticesContainer from "../../container/admin/notices-master";

const Notices = () => {
    return <NoticesContainer />;
};

export default Notices;